import FacebookIcon from "@mui/icons-material/Facebook";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";

export const serviceItems = [
  {
    label: "Ship with Us",
    id: "shipwithus",
    icon: (
      <LocalShippingIcon sx={{ fontSize: 50, color: "rgba(33, 93, 213, 1)" }} />
    ),
    description:
      "Reliable freight solutions tailored to your timeline. Coast-to-coast or local, we deliver.",
  },
  {
    label: "Truck Repair",
    id: "truckrepair",
    icon: (
      <BuildCircleIcon sx={{ fontSize: 50, color: "rgba(33, 93, 213, 1)" }} />
    ),
    description:
      "Our in-house diesel shop offers expert diagnostics and repairs to keep your fleet rolling.",
  },
  {
    label: "Truck Wash",
    id: "truckwash",
    icon: (
      <LocalCarWashIcon sx={{ fontSize: 50, color: "rgba(33, 93, 213, 1)" }} />
    ),
    description:
      "Professional wash services that restore shine and remove grime—because presentation matters.",
  },
  {
    label: "Restacking",
    id: "restacking",
    icon: (
      <StackedBarChartIcon
        sx={{ fontSize: 50, color: "rgba(33, 93, 213, 1)" }}
      />
    ),
    description:
      "Efficient restacking and load adjustments to prevent damage and meet delivery standards.",
  },
  {
    label: "Roadside Service",
    id: "roadsideservice",
    icon: (
      <MiscellaneousServicesIcon
        sx={{ fontSize: 50, color: "rgba(33, 93, 213, 1)" }}
      />
    ),
    description:
      "24/7 emergency support for breakdowns, lockouts, and unexpected delays—wherever you are.",
  },
];

export const locationItems = [
  { label: "Texas", id: "https://maps.app.goo.gl/4S6a2GUAp3pFa4fKA" },
  { label: "California", id: "https://maps.app.goo.gl/sCetme3VRJXH7xKX8" },
];

export const navLinks = [
  { label: "Home", page: "/" },
  { label: "Services", page: "", submenu: serviceItems },
  //{ label: "Partners", page: "/partners" },
  { label: "Location", page: "", submenu: locationItems },
  { label: "Join Our Team!", page: "/joinus" },
  { label: "About Us", page: "/aboutus" },
];

export const socialLinks = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/p/Flyhi-Trans-Inc-100054568834830/",
    icon: <FacebookIcon />,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/flyhitrans-inc",
    icon: <LinkedInIcon />,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/flyhitrans?igsh=eGJsaWY2MGYxODJv",
    icon: <InstagramIcon />,
  },
  {
    label: "Location",
    href: "https://maps.app.goo.gl/4S6a2GUAp3pFa4fKA",
    icon: <LocationOnIcon />,
  },
];

export const stats = [
  {
    label: "in Business",
    value: "10+ Years",
    description: "A decade of trusted logistics and strong partnerships.",
  },
  {
    label: "On-Time Delivery",
    value: "99%",
    description: "Precision scheduling that keeps your cargo on track.",
  },
  {
    label: "Fleet Size",
    value: "100+ Tractors",
    description: "A robust fleet ready to move freight coast to coast.",
  },
  {
    label: "Trailers",
    value: "150+",
    description: "Heavy-duty reefers powering our long-haul operations.",
  },
  {
    label: "Loads Delivered",
    value: "50,000+",
    description:
      "Thousands of successful deliveries, each treated as mission-critical.",
  },
  {
    label: "Support Staff",
    value: "30+",
    description:
      "Dedicated professionals ensuring smooth operations across the board.",
  },
];
